import React, { useState, useMemo, useCallback } from "react";
import { AccordionContext, useAccordion, useAccordionContext } from "./hooks/useAccordion";
import { StyledAccordion } from "./styled";
import { AccordionItem, AccordionTitle } from "./components";
import { useKeyboardNavigation } from "./hooks/useKeyboardNavigation";
var Accordion = function (_a) {
    var children = _a.children, spacing = _a.spacing, className = _a.className, style = _a.style;
    var _b = useState(""), activeId = _b[0], setActiveId = _b[1];
    var _c = useKeyboardNavigation(children), focusedNodeId = _c.focusedNodeId, onKeyDown = _c.onKeyDown;
    var onAccordionClick = useCallback(function (id) {
        var nextId = activeId === id ? "" : id;
        focusedNodeId.current = nextId;
        setActiveId(nextId);
    }, [activeId, focusedNodeId]);
    var context = useMemo(function () { return ({
        activeId: activeId,
        onAccordionClick: onAccordionClick,
    }); }, [activeId, onAccordionClick]);
    return (React.createElement(AccordionContext.Provider, { value: context },
        React.createElement(StyledAccordion, { style: style, className: className, spacing: spacing || "1rem", onKeyDown: onKeyDown }, children)));
};
export { Accordion, AccordionItem, AccordionTitle, useAccordion, useAccordionContext };
